export default __webpack_public_path__ + "static/media/Backbay_Lounge.3f2a947c.mp3";